import Logo from "./Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-slate-800/80 py-14">
      <div className="max-w-6xl mx-auto px-5 flex flex-col items-center gap-8">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-sky-400 text-center">
            As seen on/featured in
          </p>
          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-10 gap-y-3 opacity-60">
            {["Yahoo! Finance", "Bloomberg", "MarketWatch", "Digital Journal", "Forbes"].map((n) => (
              <span key={n} className="text-sm font-bold tracking-wide text-slate-300" style={{ fontFamily: "Georgia, serif" }}>
                {n}
              </span>
            ))}
          </div>
        </div>
        <div className="w-full h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent" />
        <div className="flex flex-col items-center gap-4">
          <Logo />
          <p className="text-xs text-slate-500 text-center max-w-md leading-relaxed">
            Breeze Wealth Management © 2026. All Rights Reserved. Become a licensed life insurance advisor with our
            fast-growing IMO.
          </p>
        </div>
      </div>
    </footer>
  );
}
